import { Button } from '@mui/material'
import { styled } from '@mui/styles'

export const CustomButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.spacing(1.25),
  height: theme.spacing(9),
  width: theme.spacing(29),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
  },
}))

export const PrimaryButton = styled(CustomButton)(({ theme }) => ({
  color: theme.palette.text.white,
  backgroundColor: theme.palette.primary.main,
  fontWeight: 600,
  '&:hover': {
    backgroundColor: theme.palette.primary.hover,
  },
}))

export const SecondaryButton = styled(CustomButton)(({ theme }) => ({
  color: theme.palette.primary.main,
  border: `1px solid ${theme.palette.generalUi.borders}`,
  backgroundColor: theme.palette.common.white,
  fontWeight: 600,
}))

export const TertiaryButton = styled(CustomButton)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.defaultSub,
}))
